<template>
  <div class="content">
    <div class="title">小程序授权</div>
<!--    授权第一步-->
<!--    <div class="auth-wrap" >-->
<!--      <div class="auth-box">-->
<!--        <el-row>-->
<!--          <el-col :span="6" class="auth-logo-div">-->
<!--            <img class="auth-logo" src="../../../../assets/img/official/wechat_shouquanshuoming.png" alt="">-->
<!--          </el-col>-->
<!--          <el-col :span="18">-->
<!--            <div class="auth-title">授权说明</div>-->
<!--            <div class="auth-tip">-->
<!--              <div class="part-box">-->
<!--                <div class="part-circle"></div>-->
<!--                <div class="part-content"><span>授权过程需要该公众号的管理员扫码，管理员一般是注册公众号的人，运营者是不能授权的。</span></div>-->
<!--              </div>-->
<!--              <div class="part-box">-->
<!--                <div class="part-circle"></div>-->
<!--                <div class="part-content"><span>如果你是公众号的管理员，点击下方按钮，扫码授权即可。</span></div>-->
<!--              </div>-->
<!--              <div class="part-box">-->
<!--                <div class="part-circle"></div>-->
<!--                <div class="part-content"><span>如果你是公众号的运营者，点击下方按钮，在授权二维码出来后，把二维码截图发给管理员，授权过程中请不要关闭当前页面，等对方扫码通过后，这边就可以授权成功了。</span></div>-->
<!--              </div>-->
<!--              <div class="btn-box">-->
<!--                <span class="auth-btn">-->
<!--                  <a :href="authLink" target="_blank">点击开始授权公众号</a>-->
<!--                </span>-->
<!--              </div>-->
<!--            </div>-->
<!--          </el-col>-->
<!--        </el-row>-->
<!--      </div>-->
<!--    </div>-->
<!--    授权成功添加商户号-->
    <div class="success">
      <div class="success-top">
        <div class="top-status">
          <img src="@/assets/img/icon_succeed.png" alt="">
          <div class="status">
            <div class="title">{{isOpen?'小程序开通成功':'小程序授权成功'}}</div>
            <!-- <div class="text">{{isOpen?'小程序开通成功后，等待代码部署审核，您可以在小程序基础信息中查看进度':'恭喜您，成功绑定小程序'}}</div> -->
          </div>
        </div>
        <div class="success-top-text">小程序授权成功后，等待代码部署审核，您可以在小程序基础信息中查看进度；</div>
        
        <!-- <div class="success-top-text">小程序授权成功后，等待代码部署审核，您可以在小程序基础信息中查看进度；<span><a  style="color:red;" target="_blank" href="https://www.yuque.com/u32516990/aspkll/gb3r6f">
          查看操作说明</a></span><img src="@/assets/img/top_icon_arrow_red.png" alt="">
        </div>
          <div class="success-top-button" v-if="isOpen">前往查看</div> -->
      </div>
      <div class="handel-btn" @click="goPaths">前往查看</div>
      <!-- <div class="success-hint">
        <div class="top-text">
          <img src="@/assets/img/top_icon_error.png" alt="">
          <div class="text">没有微信商户号？点此申请<span><a href="https://pay.weixin.qq.com/index.php/apply/applyment_home/guide_normal">微信商户号</a></span>，如已有商户号，您可以点此查看<span><a href="https://pay.weixin.qq.com/index.php/core/home/login?return_url=%2F">商户号信息</a></span></div>
          <img src="@/assets/img/icon_arrow_blue.png" alt="">
        </div>
      </div> -->
      <!-- <div class="success-from">
        <div class="from-item">
          <div class="item-text"><span>*</span>微信商户号</div>
          <input type="text" placeholder="请输入" v-model="from.merchantId">
        </div>
        <div class="from-item">
          <div class="item-text"><span>*</span>微信密钥key</div>
          <input type="text" placeholder="请输入" v-model="from.merchantKey">
        </div>
        <div class="from-item">
          <div class="item-text"><span>*</span>apiclient_cert.pem路径</div>
          <el-upload
            class="upload-demo"
            :action="action"
            :on-remove="handleRemove"
            multiple
            :limit="3"
            :headers="headers"
            :on-success="uploadSuccess"
            :on-error="uploadError"
            :file-list="fileList">
            <div class="item-button"><img src="@/assets/img/icon_upload.png" alt="">点击上传</div>
          </el-upload>
        </div>
        <div class="from-item">
          <div class="item-text"><span>*</span>apiclient_key.pem路径</div>
          <el-upload
            :headers="headers"
            class="upload-demo"
            :action="action"
            :on-remove="handleRemoveSy"
            :on-success="uploadSuccessSy"
            :on-error="uploadError"
            multiple
            :limit="3"
            :file-list="fileList">
            <div class="item-button"><img src="@/assets/img/icon_upload.png" alt="">点击上传</div>
          </el-upload>
        </div>
        <div class="from-item">
          <div class="item-text"><span>*</span>apiclient_key.12路径</div>
          <el-upload
            class="upload-demo"
            :headers="headers"
            :action="action"
            :on-remove="handleRemove12"
            :on-success="uploadSuccess12"
            :on-error="uploadError"
            multiple
            :limit="3"
            :file-list="fileList">
            <div class="item-button"><img src="@/assets/img/icon_upload.png" alt="">点击上传</div>
          </el-upload>
        </div>
      </div> -->
      <!-- <div class="success-button">
        <div class="button-accomplish" @click="add">完成</div>
        <div class="button-it" @click="dialogVisible = true">使用官方商户号收款</div>
      </div> -->
    </div>
    <!-- <el-dialog
      title="使用官方商户号说明"
      :visible.sync="dialogVisible"
      width="40%"
      :before-close="handleClose">
     <div class="dialog">
       <div class="dialog-title">确认使用官方商户号收款，遵守以下原则：</div>
       <div class="dialog-text">客户投诉请优先配合处理，否则将收回商户号使用权限</div>
       <div class="dialog-button">
         <div class="button-cancel" @click="dialogVisible = false">取消</div>
         <div class="button-success" @click="bind">同意并使用</div>
       </div>
     </div>
    </el-dialog>
    <div class="number" v-if="false">
      <div class="number-text">商户号：<span>18888888</span></div>
      <div class="number-copy"
           v-clipboard:copy="'www.baidu.com'"
           v-clipboard:success="onCopy"
           v-clipboard:error="onError">复制</div>
    </div> -->
  </div>
</template>

<script>
import mini from '@/api/mini'
import {getUserUUID} from "../../../../utils/auth";
const MiniModel = new mini()
export default {
  name: "index",
  data(){
    return{
      fileList:[],
      dialogVisible:false,
      isOpen:false, // 是否开通了
      // 提交表单
      from:{
        appKey:'',
        merchantKey:'',
        mchCert:'',
        mchKey:'',
        mchP:'',
        merchantId:'',
        userUuid:getUserUUID()
      },
      pitIdZfb:'', //席位id
      appKey:'',
      merchantId:'', //外层绑定接口返回的商户id
      action:process.env.VUE_APP_NEW_OPEN_URL  + '/movie/open/upload/merchant',
      isBind:true,
      headers:{
        OPENTOKEN:localStorage.getItem('java-token')
      },
      isAjax:false
    }
  },
  mounted() {
    console.log(localStorage.getItem('appIdZfb'),'appIdZfb==56')
    console.log(localStorage.getItem('pitIdZfb'),'====3==')
    // 获取授权传过来的pitId来去appKey
    if(this.$route.query.pitIdZfb !== undefined){
      this.pitIdZfb = this.$route.query.pitIdZfb
    }else{
      this.pitIdZfb = localStorage.getItem('pitIdZfb')
    }
    this.appKey = localStorage.getItem('appKeyMini')
    this.from.appKey = localStorage.getItem('appKeyMini')

    // localStorage.removeItem('isMerchant')
    // this.getAppKey()
    this.getFun()
    console.log(this.appKey,'this.appKeythis.appKey==777',this.pitIdZfb)
  },
  methods:{
    handleRemove(file, fileList) {
      console.log(file, fileList);
    },
    handleRemoveSy(file, fileList) {
      console.log(file, fileList);
    },
    // 上传成功钩子
    uploadSuccess(response){
      console.log('response',response)
      this.from.mchCert = response.data
    },
    // 上传成功钩子私钥
    uploadSuccessSy(response){
      console.log('response',response)
      this.from.mchKey = response.data
    },
    handleRemove12(file, fileList) {
      console.log(file, fileList);
    },
    // 上传成功钩子
    uploadSuccess12(response){
      console.log('response',response)
      this.from.mchP = response.data
    },
    // 上传成功钩子私钥
    uploadSuccessSy12(response){
      console.log('response',response)
    },
    uploadError(err){
      console.log('err',err)
    },
    handleClose(){
      this.dialogVisible = false
    },
    //复制
    onCopy: function(e) {
      this.$Message.success('复制成功');
    },
    onError: function(e) {
      this.$Message.success('复制失败');
    },
    // 添加商户号
    add(){
      var that = this
      if(!this.isAjax){
        this.isAjax = true
        // MiniModel.addMini(this.from).then(res=>{
        //   if (res.data.code == 200) {
        //     console.log(res)
        //     // 获取到商户号id，为绑定做准备
        //     this.merchantId = res.data.data.id
        //
        //   } else {
        //     this.$message.error(res.data.info)
        //   }
        //   this.isAjax = false
        // })
        let param = {
          appKey:this.appKey,
          ...this.from
          // merchantId:this.merchantId
        }
        MiniModel.bindMini(param).then(res=>{
          if (res.data.code == 200) {
            console.log(res)
            this.$message.success('绑定成功')
            // 重新请求来展示不同页面
            setTimeout(()=>{
              that.$emit('getBuySeat',this.appKey)
            },1000)
          } else {
            this.isAjax = false
            this.$message.error(res.data.info || res.data.message)
          }
        })
      }else {

      }

    },
    // 使用官方商户号
    bind(){
      let that = this
      let params = {
        appKey:this.appKey
      }
      if(this.isBind){
        this.isBind = false
        MiniModel.bindMiniGf(params).then(res=>{
          if (res.data.code == 200) {
            console.log(res)
            this.$message.success('绑定成功')
            this.dialogVisible = false
            setTimeout(()=>{
              that.$emit('getBuySeat',this.appKey)
            },1000)
          } else {
            console.log(res)
            this.$message.error(res.data.info)
          }
          this.isBind = true
        })
      }
    },
    getFun() {
      let active = localStorage.getItem('miniActiveZfb')
      console.log('没有')
      MiniModel.getMiniNum({channelType: 4}).then(reg => {
        if (reg.data.code == 200) {
          console.log(reg,'regreg列表')
          let data = reg.data.data.openAppList;
          if(data.length > 0) {
            let appKeys = data[active].appKey
            console.log(appKeys,'匹配的appKeys')
            localStorage.setItem('appKeyMini',appKeys)
            this.appKey = appKeys
            this.from.appKey = appKeys
            console.log(data[active].appKey,'PPP==')
          }
        }
      })
    },
    // 获取appKey
    getAppKey(){
      let params = {
        channelType:4,
        id:this.pitIdZfb
      }
      console.log(params,'params')
      MiniModel.getMiniAppKey(params).then(res=>{
        console.log(res,'获取appKey=')
        if (res.data.code == 200) {
          console.log(res)
          let appKey = res.data.data.appKey
          if(appKey) {
            this.appKey = res.data.data.appKey
            this.from.appKey = res.data.data.appKey
            localStorage.setItem('appKeyMini', this.appKey)
          }else{
            let active = localStorage.getItem('miniActiveZfb')
            console.log('没有')
            MiniModel.getMiniNum({channelType: 4}).then(reg => {
              if (reg.data.code == 200) {
                console.log(reg,'regreg')
                let data = reg.data.data.openAppList;
                if(data.length > 0) {
                  let appKeys = data[active].appKey
                  localStorage.setItem('appKeyMini',appKeys)
                  console.log(data[active].appKey,'PPP==')
                }
              }
            })
          }
        } else {
          this.$message.error(res.data.info)
        }
      })
    },
    goPaths() {
      console.log('SSS')
      this.$emit('openSet','')
      // this.$router.push({
      //   path:'/pc/zfbMiniProgram/set'
      // })
    },
  }
}
</script>

<style scoped lang="less">
.handel-btn{
  width: 150px;
  height: 40px;
  background: #FF8622;
  color: #fff;
  border-radius: 4px;
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
  margin-top: 20px;
  margin-bottom: 20px;
}
.content{
  padding: 20px 40px;
  margin: 20px 260px;
  background: #FFFFFF;
  box-shadow: 0px 2px 6px 0px rgba(0,0,0,0.06);
  border-radius: 8px;
  // min-height: 800px;
  position: relative;
  .title{
    font-size: 18px;
    font-family: Alibaba-PuHuiTi-M, Alibaba-PuHuiTi;
    font-weight: normal;
    color: #222222;
    line-height: 25px;
  }
  .success{
    display: flex;
    flex-direction: column;
    align-items: center;
    margin-top: 80px;
    .success-top{
      text-align: center;
      .top-status{
        display: flex;
        align-items: center;
        justify-content: center;
        .status{
          margin-left: 20px;
          .title{
            font-size: 24px;
            font-family: Alibaba-PuHuiTi-M, Alibaba-PuHuiTi;
            font-weight: normal;
            color: #222222;
            line-height: 33px;
          }
          .text{
            font-size: 14px;
            font-family: Alibaba-PuHuiTi-R, Alibaba-PuHuiTi;
            font-weight: normal;
            color: #666666;
            line-height: 20px;
          }
        }
      }
      .success-top-text{
        font-size: 14px;
        font-family: Alibaba-PuHuiTi-R, Alibaba-PuHuiTi;
        font-weight: normal;
        color: #666666;
        line-height: 20px;
        margin-top: 25px;
      }
      .success-top-button{
        width: 120px;
        height: 36px;
        background: #FFFFFF;
        border-radius: 2px;
        border: 1px solid #FF8622;
        text-align: center;
        font-size: 14px;
        font-family: Alibaba-PuHuiTi-R, Alibaba-PuHuiTi;
        font-weight: normal;
        color: #FF8622;
        line-height: 36px;
        margin: auto;
        margin-top: 51px;
      }
    }
  }
}
.success-hint{
  height: 40px;
  background: #FFF6F8;
  border-radius: 4px;
  border: 1px solid #FFCAD5;
  width: 100%;
  margin-top: 50px;
  .top-text{
    height: 40px;
    display: flex;
    align-items: center;
    margin-left: 16px;
    .text{
      font-size: 14px;
      font-family: Alibaba-PuHuiTi-R, Alibaba-PuHuiTi;
      font-weight: normal;
      color: #666666;
      line-height: 20px;
      margin-left: 8px;
      span{
        color: #FF4F76;
        cursor: pointer;
      }
    }
  }
}
.success-from{
  padding-bottom: 50px;
  .from-item{
    display: flex;
    align-items: center;
    margin-top: 30px;
    .item-text{
      width: 170px;
      font-size: 14px;
      font-family: Alibaba-PuHuiTi-R, Alibaba-PuHuiTi;
      font-weight: normal;
      color: #666666;
      line-height: 20px;
      margin-right: 30px;
      span{
        color:#FF4F76 ;
        margin-right: 5px;
      }
    }
    .item-link{
      font-size: 14px;
      font-family: Alibaba-PuHuiTi-R, Alibaba-PuHuiTi;
      font-weight: normal;
      color: #333333;
      line-height: 20px;
    }
    .item-copy{
      width: 56px;
      height: 24px;
      background: #F5F5FA;
      border-radius: 2px;
      margin-left: 20px;
      text-align: center;
      cursor: pointer;
      font-size: 12px;
      font-family: Alibaba-PuHuiTi-R, Alibaba-PuHuiTi;
      font-weight: normal;
      color: #999999;
      line-height: 24px;
    }
    .item-span{
      font-size: 12px;
      font-family: Alibaba-PuHuiTi-R, Alibaba-PuHuiTi;
      font-weight: normal;
      color: #999999;
      line-height: 17px;
      margin-left: 10px;
      span{
        color: #3D9EFC;
      }
    }
    .item-button{
      width: 112px;
      height: 36px;
      background: #FFFFFF;
      border-radius: 2px;
      border: 1px solid #3D9EFC;
      text-align: center;
      line-height: 36px;
      font-size: 14px;
      font-family: Alibaba-PuHuiTi-R, Alibaba-PuHuiTi;
      font-weight: normal;
      color: #3D9EFC;
      display: flex;
      align-items: center;
      justify-content: center;
      cursor: pointer;
    }
    input{
      width: 320px;
      height: 36px;
      background: #FFFFFF;
      border-radius: 2px;
      border: 1px solid #EEEEEE;
      padding: 0 12px;
    }
  }
}
.success-button{
  height: 64px;
  background: #FFFFFF;
  box-shadow: 0px -1px 4px 0px rgba(0,0,0,0.1);
  border-top: 1px solid #eeeeee;
  display: flex;
  align-items: center;
  justify-content: center;
  position: absolute;
  bottom: 0;
  width: 100%;
  left: 0;
  right: 0;
  margin: auto;
  .button-accomplish{
    width: 76px;
    height: 36px;
    background: #FF8622;
    border-radius: 2px;
    font-size: 14px;
    font-family: Alibaba-PuHuiTi-R, Alibaba-PuHuiTi;
    font-weight: normal;
    color: #FFFFFF;
    line-height: 36px;
    text-align: center;
    cursor: pointer;
    margin-right: 20px;
  }
  .button-it{
    width: 172px;
    height: 36px;
    border-radius: 2px;
    border: 1px solid #FF8622;
    text-align: center;
    font-size: 14px;
    font-family: Alibaba-PuHuiTi-R, Alibaba-PuHuiTi;
    font-weight: normal;
    color: #FF8622;
    line-height: 36px;
    cursor: pointer;
  }
}
.dialog{
  padding: 20px 80px;
  .dialog-title{
    font-size: 16px;
    font-family: Alibaba-PuHuiTi-R, Alibaba-PuHuiTi;
    font-weight: normal;
    color: #333333;
    line-height: 24px;
  }
  .dialog-text{
    font-size: 14px;
    font-family: Alibaba-PuHuiTi-R, Alibaba-PuHuiTi;
    font-weight: normal;
    line-height: 24px;
    margin-top: 8px;
    color: red;
  }
  .dialog-button{
    display: flex;
    align-items: center;
    margin-top: 48px;
    justify-content: center;
    .button-success{
      width: 110px;
      height: 32px;
      background: #FF8622;
      border-radius: 2px;
      font-size: 14px;
      font-family: Alibaba-PuHuiTi-R, Alibaba-PuHuiTi;
      font-weight: normal;
      color: #FFFFFF;
      line-height: 32px;
      text-align: center;
      cursor: pointer;
    }
    .button-cancel{
      width: 76px;
      height: 32px;
      border-radius: 2px;
      border: 1px solid #EEEEEE;
      margin-right: 10px;
      font-size: 14px;
      font-family: Alibaba-PuHuiTi-R, Alibaba-PuHuiTi;
      font-weight: normal;
      color: #333333;
      line-height: 32px;
      text-align: center;
      cursor: pointer;
    }
  }
}
.number{
  width: 100%;
  height: 64px;
  background: #FFFFFF;
  border-radius: 4px;
  opacity: 0.8;
  border: 1px solid #E8E8E8;
  display: flex;
  align-items: center;
  justify-content: center;
  .number-text{
    font-size: 14px;
    font-family: Alibaba-PuHuiTi-R, Alibaba-PuHuiTi;
    font-weight: normal;
    color: #666666;
    line-height: 20px;
    span{
      color: #333333;
    }
  }
  .number-copy{
    width: 56px;
    height: 24px;
    background: #F5F5FA;
    border-radius: 2px;
    margin-left: 20px;
    text-align: center;
    cursor: pointer;
    font-size: 12px;
    font-family: Alibaba-PuHuiTi-R, Alibaba-PuHuiTi;
    font-weight: normal;
    color: #999999;
    line-height: 24px;
  }
}
.auth-wrap .auth-box{
  padding: 60px 30px;
}
.auth-wrap .auth-box .auth-logo-div{
  padding-right: 30px;
}
.auth-wrap .auth-box .auth-logo{
  width: 100%;padding-top: 30px;
}
.auth-wrap .auth-box .auth-title,.auth-detail .auth-title{
  font-family: Alibaba-PuHuiTi-M;
  font-size: 18px;
  color: #222222;
}
.auth-wrap .auth-box .auth-tip,.auth-detail .auth-tip{
  font-family: Alibaba-PuHuiTi-R;
  font-size: 13px;
  color: #666666;
  margin-top: 10px;
}
.auth-wrap .auth-box .part-box,.auth-detail .part-box {
  display: flex;
  flex-direction: row;
  padding: 4px 0;
}
.auth-wrap .auth-box .part-circle,.auth-detail .part-circle {
  width: 6px;
  height: 6px;
  border-radius: 3px;
  background: #D63036;
  margin: 5px 8px 5px 0;
}
.auth-detail .part-circle {
  background: #999999;
}
.auth-wrap .auth-box .part-content,.auth-detail .part-content {
  width: 90%;
}
.auth-wrap .auth-box .btn-box{
  padding: 20px 10px;
}
.auth-wrap .auth-box .btn-box .auth-btn{
  font-family: Alibaba-PuHuiTi-R;
  background: #FF8622;
  border-radius: 2px;
  color: #FFFFFF;
  padding: 6px 15px;
}
.auth-wrap .auth-box .btn-box .auth-btn a{
  color: #FFFFFF;
}
@media screen and (max-width: 1750px) {
  .content {
    margin: 20px 60px !important;
  }
}
/deep/.el-dialog__header{
  border-bottom: 1px solid #EEEEEE;
}

</style>



// WEBPACK FOOTER //
// src/views/pc/zfbMiniProgram/authorization/index.vue